import { plural } from '@cian/utils';

export function getLabel(value: number): string {
  return `${value} ${plural(value, ['гость', 'гостя', 'гостей'])}`;
}
